module.exports = __webpack_public_path__ + "img/dt1.60919e97.png";